/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { getRealmInfo, getUserRealmSettings } from "../../services/setting";
import { showErrorAction } from "../error/errorActionCreator";
import { getRealmSettingsStart, getRealmSettingsSuccess, getRealmSettingsFailure } from "./realmSettingsActionCreator";
import { SET_REALM_INFO } from "./types";

export const getRealmSettings = async (dispatch: Function) => {
  dispatch(getRealmSettingsStart());
  try {
    const realmSettings = await getUserRealmSettings();
    dispatch(getRealmSettingsSuccess(realmSettings));
  } catch (error: any) {
    dispatch(getRealmSettingsFailure(error));
    dispatch(showErrorAction({ message: `${`Error in fetching realm settings`}` }));
  }
};

export const getRealmDetails = async (dispatch: Function) => {
  try {
    const realmInfo = await getRealmInfo();
    dispatch({ type: SET_REALM_INFO, realmInfo });
  } catch (error: any) {
    dispatch(showErrorAction({ message: `${`Error in fetching realm info`}` }));
  }
}